import { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export const useKeyboardShortcuts = () => {
  const navigate = useNavigate();

  const handleKeyPress = useCallback(
    (event) => {
      // Check if user is typing in an input field
      const isTyping = ["INPUT", "TEXTAREA", "SELECT"].includes(
        event.target.tagName
      );

      // Only trigger shortcuts when Ctrl/Cmd is pressed and not typing
      if ((event.ctrlKey || event.metaKey) && !isTyping) {
        switch (event.key.toLowerCase()) {
          case "n":
            // Ctrl/Cmd + N: New post
            event.preventDefault();
            navigate("/add-post");
            toast.success("Creating new post");
            break;

          case "p":
            // Ctrl/Cmd + P: View posts
            event.preventDefault();
            navigate("/posts");
            break;

          case "d":
            // Ctrl/Cmd + D: Dashboard
            event.preventDefault();
            navigate("/dashboard");
            break;

          case "s":
            // Ctrl/Cmd + S: Save (trigger form submit if on add/edit page)
            event.preventDefault();
            const submitButton = document.querySelector(
              'button[type="submit"]'
            );
            if (submitButton) {
              submitButton.click();
            } else {
              toast("No form to save", { icon: "💾" });
            }
            break;

          case "/":
            // Ctrl/Cmd + /: Focus search
            event.preventDefault();
            const searchInput = document.querySelector(
              'input[type="text"][placeholder*="Search"]'
            );
            if (searchInput) {
              searchInput.focus();
            }
            break;

          default:
            break;
        }
      }

      // ESC key to close modals
      if (event.key === "Escape") {
        const closeButton = document.querySelector('[aria-label="Close"]');
        if (closeButton) {
          closeButton.click();
        }
      }
    },
    [navigate]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleKeyPress]);

  return {
    shortcuts: [
      { keys: "Ctrl/Cmd + N", action: "New Post" },
      { keys: "Ctrl/Cmd + P", action: "View Posts" },
      { keys: "Ctrl/Cmd + D", action: "Dashboard" },
      { keys: "Ctrl/Cmd + S", action: "Save" },
      { keys: "Ctrl/Cmd + /", action: "Search" },
      { keys: "ESC", action: "Close Modal" },
    ],
  };
};
